import ApiClient from 'api-client/ApiClient'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import ActionsSet from 'core/actions/ActionsSet'
import ListAction from 'core/actions/ListAction'
import CreateAction from 'core/actions/CreateAction'
import CustomAction from 'core/actions/CustomAction'
import UpdateAction from 'core/actions/UpdateAction'
import DeleteAction from 'core/actions/DeleteAction'
import store from 'app/store'
import { cacheActions } from 'core/caching/cacheReducers'
import { noop } from 'utils/fp'

const { dispatch } = store
const { mors } = ApiClient.getInstance()

export const leasePolicyActions = ActionsSet.make<DataKeys.LeasePolicies>({
  uniqueIdentifier: 'tenant_uuid',
  entityName: entityNamesByKey.Flavors,
  cacheKey: DataKeys.LeasePolicies,
})

export const listLeasePolicies = leasePolicyActions.add(
  new ListAction<DataKeys.LeasePolicies>(async () => {
    return mors.getLeasePolicies()
  }),
)

export const createLeasePolicy = leasePolicyActions.add(
  new CreateAction<DataKeys.LeasePolicies, { tenantId; body }>(async ({ tenantId, body }) => {
    const response = await mors.createLeasePolicy({ tenantId, body })
    if (!response.success) {
      throw new Error(`Lease Policy creation for tenant ${tenantId} failed`)
    }
    const newLeasePolicy = await mors.getLeasePolicy({ tenantId })
    return newLeasePolicy
  }),
)

export const updateLeasePolicy = leasePolicyActions.add(
  new UpdateAction<
    DataKeys.LeasePolicies,
    {
      tenantId: string
      body: unknown
    }
  >(async ({ tenantId, body }) => {
    const response = await mors.updateLeasePolicy({ tenantId, body })
    if (!response.success) {
      throw new Error(`Lease Policy update for tenant ${tenantId} failed`)
    }
    const updatedLeasePolicy = await mors.getLeasePolicy({ tenantId })
    return updatedLeasePolicy
  }),
)

export const deleteLeasePolicy = leasePolicyActions.add(
  new DeleteAction<DataKeys.LeasePolicies, { tenant_uuid: string }>(async ({ tenant_uuid }) => {
    await mors.deleteLeasePolicy({ tenantId: tenant_uuid })
  }),
)

export const leaseActions = ActionsSet.make<DataKeys.Leases>({
  uniqueIdentifier: 'instance_uuid',
  entityName: entityNamesByKey.Leases,
  cacheKey: DataKeys.Leases,
})

export const listLeases = leaseActions.add(
  new ListAction<DataKeys.Leases>(async () => {
    return mors.getVmLeases({ tenantId: '' })
  }),
)

export const createLease = leaseActions.add(
  new CreateAction<DataKeys.Leases, { tenantId: string; vmId: string; body: unknown }>(
    async ({ tenantId, vmId, body }) => {
      const response = await mors.createVmLease({ tenantId, vmId, body })
      if (!response.success) {
        throw new Error(`Lease creation for VM ${vmId} failed`)
      }
      const newLease = await mors.getVmLease({ tenantId, vmId })
      return newLease
    },
  ),
)

export const updateLease = leaseActions.add(
  new UpdateAction<
    DataKeys.Leases,
    {
      tenantId: string
      vmId: string
      body: unknown
    }
  >(async ({ tenantId, vmId, body }) => {
    const response = await mors.updateVmLease({ tenantId, vmId, body })
    if (!response.success) {
      throw new Error(`Lease update for vm ${vmId} failed`)
    }
    const updatedLease = await mors.getVmLease({ tenantId, vmId })
    return updatedLease
  }),
)
